<template>
    <b-modal :id="id"
        :no-close-on-backdrop="true"
        :title="$t('create_new_category')" ref="innermodal">
            <form ref="form">
                <div v-if="$v.$error" class="alert alert-danger x-error">
                    <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលប្រភេទមុខទំនិញ</div>
                </div>
                <div class="row-container">
                    <div class="col-img">
                        <img :src="img" alt="CATEGORY IMG"
                        class="img-thumbnail" @click="$refs.file.click()"
                        style="cursor:pointer">
                        <input type="file" ref="file" hidden  @change="fileChange"/>
                    </div>
                    <div class="col-form">
                        <div class="form-group">
                            <input type="text" class="form-control form-control-sm" v-model="model.Code" :placeholder="$t('code')"/>
                        </div>
                        <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                            <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model" :placeholder="$t('name')"/>
                        </div>
                        <div class="form-group">
                            <textarea type="text" class="form-control form-control-sm" v-model="model.Description" :placeholder="$t('desc')"></textarea>
                        </div>
                    </div>
                </div>
            </form>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
            </div>
    </b-modal>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        props:{
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: null
            }
        },
        validations: {
            model :{
                Name: {required}
            }
        },
        data: function(){
            return {
                model: {
                    Code: '',
                    Name: '',
                    Description: ''
                },
                img: '/img/avatars/1.jpg'
            }
        },
        methods: {
            clickSaveHandler(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    let formData = new FormData();
                    formData.append('Code', this.model.Code);
                    formData.append('Name', this.model.Name);
                    formData.append('NameEng', this.model.NameEng);
                    formData.append('Description', this.model.Description);
                    formData.append('File', this.$refs.file.files[0]);
                    formData.append('CompanyId', this.$store.state.company.Id);
                    if (this.model.Id != undefined && this.model.Id != null && this.model.Id != '') {
                        formData.append('Id', this.model.Id);
                    }
                    this.$api().post('category/save', formData).then(res => {
                        if (this.$isValid(res)) {
                            this.$refs.innermodal.hide();
                            this.model = {
                                Code: '',
                                Name: '',
                                NameEng: '',
                                Description: ''
                            };
                            this.img = '/img/avatars/1.jpg';
                            this.$emit('done');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            fileChange: function(e) {
                const file = e.target.files[0];
                this.img = URL.createObjectURL(file);
            }
        },
        watch: {
            value: function(value){
                this.model = value;
                if(this.model.Image != null){
                    this.img = this.$base() + 'image/categories/' + this.model.Image;
                }else this.img = '/img/avatars/1.jpg';
            }
        }
    }
</script>
<style scoped>
    .row-container{
        display: flex;
        justify-content: space-around;
    }
    .col-img{
        width: 150px;
        float: left;
    }
    .col-img img{
        width: 150px;
        height: 108px;
    }
    .col-form{
        width: 100%;
        padding: 0 15px;
    }
</style>
